import { Loader2, Package, Printer, Truck, X } from "lucide-react";

import { Button } from "~/components/ui/button";

interface BulkActionToolbarProps {
  selectedCount: number;
  currentTab: string;
  onClearSelection: () => void;
  onBulkInTransit?: () => void;
  onBulkDelivery?: () => void;
  onBulkAssignTransportista?: () => void;
  onBulkPrint?: () => void;
  onBulkMarkDelivered?: () => void;
  isProcessing: boolean;
  isPrinting?: boolean;
}

export function BulkActionToolbar({
  selectedCount,
  currentTab,
  onClearSelection,
  onBulkInTransit,
  onBulkDelivery,
  onBulkAssignTransportista,
  onBulkPrint,
  onBulkMarkDelivered,
  isProcessing,
  isPrinting,
}: BulkActionToolbarProps) {
  if (selectedCount === 0) return null;

  const showInTransitButton = currentTab === "accepted";
  const showDeliveryButton = currentTab === "in_transit";
  const showAssignTransportistaButton = ["in_transit", "facturado"].includes(
    currentTab
  );
  const showPrintButton = currentTab === "facturado";
  const showMarkDeliveredButton = currentTab === "facturado";

  return (
    <div className="mb-4 flex items-center justify-between rounded-lg border border-blue-200 bg-blue-50 p-4">
      <div className="flex items-center gap-4">
        <span className="text-sm font-medium text-blue-900">
          {selectedCount} pedido{selectedCount > 1 ? "s" : ""} seleccionado
          {selectedCount > 1 ? "s" : ""}
        </span>
        <Button
          variant="outline"
          size="sm"
          onClick={onClearSelection}
          className="gap-1"
        >
          <X className="h-4 w-4" />
          Limpiar seleccion
        </Button>
      </div>
      <div className="flex items-center gap-2">
        {showInTransitButton && onBulkInTransit && (
          <Button
            size="sm"
            onClick={onBulkInTransit}
            disabled={isProcessing}
            className="gap-1 bg-blue-600 hover:bg-blue-700"
          >
            <Truck className="h-4 w-4" />
            Marcar en transito ({selectedCount})
          </Button>
        )}
        {showAssignTransportistaButton && onBulkAssignTransportista && (
          <Button
            size="sm"
            onClick={onBulkAssignTransportista}
            disabled={isProcessing}
            className="gap-1 bg-orange-500 hover:bg-orange-600"
          >
            <Truck className="h-4 w-4" />
            Asignar Transportista ({selectedCount})
          </Button>
        )}
        {showPrintButton && onBulkPrint && (
          <Button
            size="sm"
            onClick={onBulkPrint}
            disabled={isProcessing || isPrinting}
            className="gap-1 bg-cyan-600 hover:bg-cyan-700"
          >
            {isPrinting ? (
              <Loader2 className="h-4 w-4 animate-spin" />
            ) : (
              <Printer className="h-4 w-4" />
            )}
            {isPrinting ? "Generando PDF..." : `Imprimir Facturas (${selectedCount})`}
          </Button>
        )}
        {showDeliveryButton && onBulkDelivery && (
          <Button
            size="sm"
            onClick={onBulkDelivery}
            disabled={isProcessing}
            className="gap-1 bg-purple-600 hover:bg-purple-700"
          >
            <Package className="h-4 w-4" />
            Registrar entregas ({selectedCount})
          </Button>
        )}
        {showMarkDeliveredButton && onBulkMarkDelivered && (
          <Button
            size="sm"
            onClick={onBulkMarkDelivered}
            disabled={isProcessing}
            className="gap-1 bg-purple-600 hover:bg-purple-700"
          >
            <Package className="h-4 w-4" />
            Marcar como Entregado ({selectedCount})
          </Button>
        )}
      </div>
    </div>
  );
}
